module.exports = __webpack_public_path__ + "fonts/SpoqaHanSansNeo-Medium.f4d5d724.woff";